module.exports = __webpack_public_path__ + "img/logo5.353f7141.png";